import React from 'react';
import Hls from 'hls.js';

export function isHlsUrl(url) {
  return /\.m3u8(\?|$)/i.test(url || '');
}

export default class HlsVideo extends React.Component {
  componentDidUpdate(prevProps) {
    if (prevProps.src !== this.props.src) {
      this._attachSource();
    }
  }

  componentWillUnmount() {
    this._teardownHls();
  }

  _setVideoRef = (node) => {
    this._node = node;
    this._attachSource();
  };

  _teardownHls = () => {
    if (this._hls) {
      this._hls.destroy();
      this._hls = null;
    }
  };

  _attachSource = () => {
    const node = this._node;
    const url = this.props.src;
    this._teardownHls();
    if (!node || !isHlsUrl(url)) {
      return;
    }
    if (node.canPlayType('application/vnd.apple.mpegurl')) {
      node.src = url;
      return;
    }
    if (Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource(url);
      hls.attachMedia(node);
      this._hls = hls;
    }
  };

  render() {
    const {children, sourceType, src, ...videoProps} = this.props;
    const hls = isHlsUrl(src);
    return (
      <video
        {...videoProps}
        ref={this._setVideoRef}
        src={hls ? undefined : src}
      >
        {hls ? null : (children || <source src={src} type={sourceType || 'video/mp4'} />)}
      </video>
    );
  }
}
